<template>
  <DetailsPlanModal
    v-if="showDetailsPlanModal"
    :plan="planSelectedView"
    @closeModal="showDetailsPlanModal = false"
  />
  <TermOfUseModal
    v-if="showTermOfUseModal"
    @closeModal="showTermOfUseModal = false"
  />
  <form class="flex-fill" @submit.prevent="createRegister">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <!--Tipo Pessoa-->
        <div class="card card-body">
          <router-link to="/" title="Voltar">
            <i class="ph-arrow-left me-1"></i>Voltar
          </router-link>
          <div class="text-center mb-2">
            <img src="@/assets/img/logo_mini.png" class="h-80px" alt="Logo" />
            <h5 class="mb-0">Realize seu Cadastro</h5>
          </div>
          <hr class="my-2" />
          <div class="row mt-2 text-center">
            <div class="col-sm-12">
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  class="form-check-input"
                  id="typePersonPJ"
                  value="1"
                  v-model="dataRegister.client.typePerson"
                />
                <label class="form-check-label" for="typePersonPJ">
                  Pessoa Jurídica
                </label>
              </div>
              <!--<div class="form-check form-check-inline">
                <input
                  type="radio"
                  class="form-check-input"
                  id="typePersonPF"
                  value="2"
                  v-model="dataRegister.client.typePerson"
                />
                <label class="form-check-label" for="typePersonPF">
                  Pessoa Física
                </label>
              </div>-->
            </div>
          </div>
        </div>
        <!--Dados da Pessoa Jurídica-->
        <div v-if="dataRegister.client.typePerson === '1'">
          <div class="card card-body pb-4">
            <h5 class="text-muted">Dados da Empresa:</h5>
            <div class="row g-3">
              <div class="col-sm-3">
                <label class="form-label">
                  CNPJ: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.client.cnpjcpf.$errors.length,
                  }"
                  placeholder="00.000.000/0000-00"
                  v-model="v$.dataRegister.client.cnpjcpf.$model"
                  v-maska="'##.###.###/####-##'"
                />
                <span
                  v-if="v$.dataRegister.client.cnpjcpf.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.dataRegister.client.cnpjcpf.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de CNPJ inválido <br />
                  Ex: 00.000.000/0000-00
                </span>
              </div>
              <div class="col-sm-5">
                <label class="form-label">
                  Razão Social: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.dataRegister.client.socialName.$errors.length,
                  }"
                  placeholder="Razão Social da Empresa"
                  v-model="v$.dataRegister.client.socialName.$model"
                />
                <span
                  v-if="v$.dataRegister.client.socialName.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Nome Fantasia: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.dataRegister.client.fantasyName.$errors.length,
                  }"
                  placeholder="Nome Fantasia da Empresa"
                  v-model="v$.dataRegister.client.fantasyName.$model"
                />
                <span
                  v-if="v$.dataRegister.client.fantasyName.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-8">
                <label class="form-label">
                  Endereço: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.client.address.$errors.length,
                  }"
                  placeholder="Endereço"
                  v-model="v$.dataRegister.client.address.$model"
                />
                <span
                  v-if="v$.dataRegister.client.address.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Número: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.client.number.$errors.length,
                  }"
                  placeholder="Número"
                  v-model="v$.dataRegister.client.number.$model"
                />
                <span
                  v-if="v$.dataRegister.client.number.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Bairro: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.dataRegister.client.district.$errors.length,
                  }"
                  placeholder="Bairro"
                  v-model="v$.dataRegister.client.district.$model"
                />
                <span
                  v-if="v$.dataRegister.client.district.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Cidade: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.client.city.$errors.length,
                  }"
                  placeholder="Cidade"
                  v-model="v$.dataRegister.client.city.$model"
                />
                <span
                  v-if="v$.dataRegister.client.city.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Estado: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{
                    'is-invalid': v$.dataRegister.client.stage.$errors.length,
                  }"
                  v-model="v$.dataRegister.client.stage.$model"
                >
                  <option value="">Selecione o Estado</option>
                  <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="DF">Distrito Federal</option>
                  <option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                  <option value="EX">Estrangeiro</option>
                </select>
                <span
                  v-if="v$.dataRegister.client.stage.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Telefone: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.client.phone.$errors.length,
                  }"
                  placeholder="(00) 98888-8888"
                  v-model="v$.dataRegister.client.phone.$model"
                  v-maska="['(##) ####-####', '(##) #####-####']"
                />
                <span
                  v-if="v$.dataRegister.client.phone.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.dataRegister.client.phone.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de telefone inválido <br />
                  Ex: (00) 98888-8888 / (00) 8888-8888
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  E-mail do Financeiro: <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.client.email.$errors.length,
                  }"
                  v-model="v$.dataRegister.client.email.$model"
                  placeholder="usuario@email.com.br"
                />
                <span
                  v-if="v$.dataRegister.client.email.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.dataRegister.client.email.email.$invalid"
                  class="invalid-feedback"
                >
                  Formato de e-mail inválido
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">Código Parceiro:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Código Parceiro"
                  v-model="dataRegister.client.partnerCode"
                />
              </div>
            </div>
          </div>
          <div class="card card-body pb-4">
            <h5 class="text-muted">Dados do Administrador:</h5>
            <div class="row g-3">
              <div class="col-sm-6">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.user.name.$errors.length,
                  }"
                  placeholder="Nome Completo"
                  v-model="v$.dataRegister.user.name.$model"
                />
                <span
                  v-if="v$.dataRegister.user.name.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.dataRegister.user.name.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O nome deve possuir pelo menos
                  {{ v$.dataRegister.user.name.minLength.$params.min }}
                  caracteres
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">Chapa:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Chapa"
                  v-model="dataRegister.user.chapa"
                />
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  E-mail: <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.user.email.$errors.length,
                  }"
                  v-model="v$.dataRegister.user.email.$model"
                  placeholder="usuario@email.com.br"
                />
                <span
                  v-if="v$.dataRegister.user.email.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.dataRegister.user.email.email.$invalid"
                  class="invalid-feedback"
                >
                  Formato de e-mail inválido
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">Telefone:</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataRegister.user.phone.$errors.length,
                  }"
                  placeholder="(00) 98888-8888"
                  v-model="v$.dataRegister.user.phone.$model"
                  v-maska="['(##) ####-####', '(##) #####-####']"
                />
                <span
                  v-if="v$.dataRegister.user.phone.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de telefone inválido <br />
                  Ex: (00) 98888-8888 / (00) 8888-8888
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--Dados da Pessoa Física-->
        <div
          v-if="dataRegister.client.typePerson === '2'"
          class="card card-body pb-4"
        >
          <h5 class="text-muted">Seus Dados:</h5>
          <div class="row g-3">
            <div class="col-sm-3">
              <label class="form-label">
                CPF: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.dataRegister.client.cnpjcpf.$errors.length,
                }"
                placeholder="000.000.000-00"
                v-model="v$.dataRegister.client.cnpjcpf.$model"
                v-maska="'###.###.###-##'"
              />
              <span
                v-if="v$.dataRegister.client.cnpjcpf.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
              <span
                v-if="v$.dataRegister.client.cnpjcpf.minLength.$invalid"
                class="invalid-feedback"
              >
                Formato de CPF inválido <br />
                Ex: 000.000.000-00
              </span>
            </div>
            <div class="col-sm-9">
              <label class="form-label">
                Nome Completo: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid':
                    v$.dataRegister.client.socialName.$errors.length,
                }"
                placeholder="Nome Completo"
                v-model="v$.dataRegister.client.socialName.$model"
              />
              <span
                v-if="v$.dataRegister.client.socialName.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-sm-8">
              <label class="form-label">
                Endereço: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.dataRegister.client.address.$errors.length,
                }"
                placeholder="Endereço"
                v-model="v$.dataRegister.client.address.$model"
              />
              <span
                v-if="v$.dataRegister.client.address.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-sm-4">
              <label class="form-label">
                Número: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.dataRegister.client.number.$errors.length,
                }"
                placeholder="Número"
                v-model="v$.dataRegister.client.number.$model"
              />
              <span
                v-if="v$.dataRegister.client.number.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-sm-4">
              <label class="form-label">
                Bairro: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.dataRegister.client.district.$errors.length,
                }"
                placeholder="Bairro"
                v-model="v$.dataRegister.client.district.$model"
              />
              <span
                v-if="v$.dataRegister.client.district.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-sm-4">
              <label class="form-label">
                Cidade: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.dataRegister.client.city.$errors.length,
                }"
                placeholder="Cidade"
                v-model="v$.dataRegister.client.city.$model"
              />
              <span
                v-if="v$.dataRegister.client.city.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-sm-4">
              <label class="form-label">
                Estado: <span class="text-danger">*</span>
              </label>
              <select
                class="form-select"
                :class="{
                  'is-invalid': v$.dataRegister.client.stage.$errors.length,
                }"
                v-model="v$.dataRegister.client.stage.$model"
              >
                <option value="">Selecione o Estado</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
                <option value="EX">Estrangeiro</option>
              </select>
              <span
                v-if="v$.dataRegister.client.stage.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-sm-4">
              <label class="form-label">
                Telefone: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.dataRegister.client.phone.$errors.length,
                }"
                placeholder="(00) 98888-8888"
                v-model="v$.dataRegister.client.phone.$model"
                v-maska="['(##) ####-####', '(##) #####-####']"
              />
              <span
                v-if="v$.dataRegister.client.phone.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
              <span
                v-if="v$.dataRegister.client.phone.minLength.$invalid"
                class="invalid-feedback"
              >
                Formato de telefone inválido <br />
                Ex: (00) 98888-8888 / (00) 8888-8888
              </span>
            </div>
            <div class="col-sm-4">
              <label class="form-label">
                E-mail: <span class="text-danger">*</span>
              </label>
              <input
                type="email"
                class="form-control"
                :class="{
                  'is-invalid': v$.dataRegister.client.email.$errors.length,
                }"
                v-model="v$.dataRegister.client.email.$model"
                placeholder="usuario@email.com.br"
              />
              <span
                v-if="v$.dataRegister.client.email.required.$invalid"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
              <span
                v-if="v$.dataRegister.client.email.email.$invalid"
                class="invalid-feedback"
              >
                Formato de e-mail inválido
              </span>
            </div>
            <div class="col-sm-4">
              <label class="form-label">Código Parceiro:</label>
              <input
                type="text"
                class="form-control"
                placeholder="Código Parceiro"
                v-model="dataRegister.client.partnerCode"
              />
            </div>
          </div>
        </div>
        <!--Planos-->
        <div v-if="dataRegister.client.typePerson != ''" class="card card-body">
          <h5 class="text-muted">Planos:</h5>
          <div v-if="plans.length > 0" class="row">
            <div class="col-sm-12">
              <label class="form-label mb-3">
                Escolha os planos desejados: <span class="text-danger">*</span>
              </label>
              <div
                v-for="(plan, index) in plans"
                :key="plan.id"
                class="form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  :true-value="plan.id"
                  false-value=""
                  v-model="dataRegister.plans[index].planId"
                  @change="handleChangeSelectionPlan($event)"
                />
                <div
                  class="card border-start border-start-secondary border-start-width-2"
                >
                  <div class="card-header d-flex align-items-center py-0">
                    <h6 class="py-3 mb-0 text-primary">
                      {{ plan.name }} (<small>{{ plan.categoryName }} </small>)
                    </h6>
                    <div class="ms-auto">
                      <span
                        role="button"
                        class="badge bg-dark"
                        title="Ver Detalhes do Plano"
                        @click="showDetailsPlans(plan)"
                      >
                        Ver Detalhes do Plano
                      </span>
                    </div>
                  </div>
                  <div v-if="dataRegister.plans[index].planId !== ''">
                    <div
                      v-if="plan.classification === '1'"
                      class="card-body text-center"
                    >
                      <div class="row">
                        <div class="col-sm-12">
                          <p class="fw-bold">
                            Número de Usuários:
                            <span class="text-danger">*</span>
                          </p>
                          <div
                            v-for="price in plan.prices"
                            :key="price.id"
                            class="form-check form-check-inline mb-2"
                          >
                            <input
                              type="radio"
                              class="form-check-input"
                              :id="`plan${index}FaixaPrice${price.id}`"
                              :value="price.id"
                              v-model="dataRegister.plans[index].priceId"
                              @change="calculatePrice"
                            />
                            <label
                              class="form-check-label"
                              :for="`plan${index}FaixaPrice${price.id}`"
                              :title="`Descrição: ${price.description}${
                                plan.monthlyPayment === '1'
                                  ? `\nValor Mensal: ${moneyToCurrencyBr(
                                      price.monthlyPrice,
                                    )}`
                                  : ''
                              }${
                                plan.annualPayment === '1'
                                  ? `\nValor Anual: ${moneyToCurrencyBr(
                                      price.annualPrice,
                                    )}`
                                  : ''
                              }`"
                            >
                              {{ price.range }}
                            </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              type="radio"
                              class="form-check-input"
                              :id="`plan${index}FaixaPriceCustom`"
                              value="0"
                              v-model="dataRegister.plans[index].priceId"
                              @change="calculatePrice"
                            />
                            <label
                              class="form-check-label"
                              :for="`plan${index}FaixaPriceCustom`"
                              title="Serão mais usuários"
                            >
                              Serão mais usuários
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="dataRegister.plans[index].priceId === '0'"
                        class="row mt-2"
                      >
                        <div
                          class="col-md-4 offset-md-4 col-sm-6 offset-sm-3 text-center"
                        >
                          <label class="form-label">
                            Informe o número desejado:
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            class="form-control text-center"
                            :class="{
                              'is-invalid':
                                dataRegister.plans[index].numberUser !== '' &&
                                dataRegister.plans[index].numberUser <
                                  plan.minUserCustomPrice,
                            }"
                            :min="plan.minUserCustomPrice"
                            step="1"
                            placeholder="Número de usuários"
                            v-model="dataRegister.plans[index].numberUser"
                            @change="calculatePrice"
                          />
                          <span
                            v-if="
                              dataRegister.plans[index].numberUser !== '' &&
                              dataRegister.plans[index].numberUser <
                                plan.minUserCustomPrice
                            "
                            class="invalid-feedback"
                          >
                            O valor deve ser igual ou maior que
                            {{ plan.minUserCustomPrice }}
                          </span>
                        </div>
                      </div>
                      <hr />
                      <div class="row">
                        <div class="col-sm-12">
                          <p class="fw-bold">
                            Tipo de Assinatura:
                            <span class="text-danger">*</span>
                          </p>
                          <div
                            v-if="plan.monthlyPayment === '1'"
                            class="form-check form-check-inline"
                          >
                            <input
                              type="radio"
                              class="form-check-input"
                              :id="`monthlySignature${index}`"
                              value="1"
                              v-model="dataRegister.plans[index].typeSignature"
                              @change="calculatePrice"
                            />
                            <label
                              class="form-check-label"
                              :for="`monthlySignature${index}`"
                            >
                              Mensal
                            </label>
                          </div>
                          <div
                            v-if="plan.annualPayment === '1'"
                            class="form-check form-check-inline"
                          >
                            <input
                              type="radio"
                              class="form-check-input"
                              :id="`annualSignature${index}`"
                              value="2"
                              v-model="dataRegister.plans[index].typeSignature"
                              @change="calculatePrice"
                            />
                            <label
                              class="form-check-label"
                              :for="`annualSignature${index}`"
                            >
                              Anual
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <p class="mb-0">
                        <strong>Total:</strong>
                        <span class="float-end">
                          {{
                            moneyToCurrencyBr(dataRegister.plans[index].price)
                          }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <span class="float-end">
                <strong>Valor Total: </strong>
                {{ moneyToCurrencyBr(priceTotal) }}
              </span>
            </div>
          </div>
          <p v-else>Nenhum plano encontrado</p>
        </div>
        <!--Termos de Uso e Adesão-->
        <div v-if="dataRegister.client.typePerson != ''" class="card card-body">
          <h5 class="text-muted">Termos de Uso e Adesão:</h5>
          <div class="row text-center mb-3">
            <div class="col-sm-12">
              <div class="form-check form-check-inline">
                <input
                  type="checkbox"
                  class="form-check-input"
                  true-value="1"
                  false-value=""
                  v-model="dataRegister.client.acceptedTerm"
                />
                <label class="form-check-label">
                  Eu li e concordo com os
                  <span
                    class="cursor-pointer text-primary"
                    title="Visualizar Termos de Uso e Adesão"
                    @click="showTermOfUseModal = true"
                  >
                    termos de uso e adesão
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-primary"
              title="Criar Cadastro"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Criar Cadastro</span>
            </button>
          </div>
          <hr />
          <div class="text-center" title="Página Inicial">
            <router-link to="/">Página Inicial</router-link>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import DetailsPlanModal from '@/components/register/DetailsPlanModal.vue'
import TermOfUseModal from '@/components/register/TermOfUseModal.vue'
import { useVuelidate } from '@vuelidate/core'
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  email,
} from '@vuelidate/validators'
import { maska } from 'maska'
import { moneyToCurrencyBr } from '@/utils/strings'
import PATHS from '@/router/routesMap'

export default {
  name: 'Register',

  setup() {
    return { v$: useVuelidate() }
  },

  directives: { maska },

  components: {
    DetailsPlanModal,
    TermOfUseModal,
  },

  data() {
    return {
      dataRegister: {
        client: {
          typePerson: '',
          cnpjcpf: '',
          socialName: '',
          fantasyName: '',
          address: '',
          number: '',
          district: '',
          city: '',
          stage: '',
          phone: '',
          email: '',
          partnerCode: '',
          acceptedTerm: '',
        },
        user: {
          name: '',
          chapa: '',
          email: '',
          phone: '',
        },
        plans: [],
      },
      plans: [],
      planSelectedView: {},
      showDetailsPlanModal: false,
      showTermOfUseModal: false,
      disableButton: false,
      moneyToCurrencyBr,
    }
  },

  computed: {
    priceTotal() {
      return this.dataRegister.plans.reduce(
        (accumulator, currentValue) => accumulator + Number(currentValue.price),
        0,
      )
    },
  },

  watch: {
    'dataRegister.client.typePerson': {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.cleanFields()
        }
      },
    },
    'dataRegister.client.cnpjcpf': {
      handler(newVal, oldVal) {
        if (newVal !== '' && newVal.length === 18) {
          this.validateCNPJ()
        }
      },
    },
  },

  methods: {
    cleanFields() {
      this.dataRegister.client = {
        typePerson: this.dataRegister.client.typePerson,
        cnpjcpf: '',
        socialName: '',
        fantasyName: '',
        address: '',
        number: '',
        district: '',
        city: '',
        stage: '',
        phone: '',
        email: '',
        partnerCode: '',
        acceptedTerm: '',
      }
      this.dataRegister.user = {
        name: '',
        chapa: '',
        email: '',
        phone: '',
      }
      this.dataRegister.plans = []
      this.v$.$reset()
      this.plans = []
      this.getPlans()
    },

    async validateCNPJ() {
      try {
        const cnpj = this.dataRegister.client.cnpjcpf.replace(/[^\d]+/g, '')
        const dataClient = await this.$store.dispatch('validateCNPJ', cnpj)

        if (dataClient.status) {
          if (dataClient.status === 'OK') {
            this.dataRegister.client.socialName = dataClient.nome
            this.dataRegister.client.fantasyName = dataClient.fantasia
            this.dataRegister.client.address = dataClient.logradouro
            this.dataRegister.client.number = dataClient.numero
            this.dataRegister.client.district = dataClient.bairro
            this.dataRegister.client.city = dataClient.municipio
            this.dataRegister.client.stage = dataClient.uf
            this.dataRegister.client.phone = dataClient.telefone
            this.dataRegister.client.email = dataClient.email
          } else if (dataClient.status === 'ERROR') {
            if (dataClient.message) {
              this.$root.$refs.notification.warning(dataClient.message)
            } else {
              this.$root.$refs.notification.error(
                'Não foi possível validar o CNPJ informado.',
              )
            }
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível validar o CNPJ informado.',
            )
          }
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível validar o CNPJ informado.',
          )
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível validar o CNPJ informado.',
          )
        }
      }
    },

    async getPlans() {
      try {
        this.plans = await this.$store.dispatch(
          'getPlans',
          this.dataRegister.client.typePerson,
        )
        this.generateArrayClientPlan()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    generateArrayClientPlan() {
      const { typePerson } = this.dataRegister.client

      for (let index = 0; index < this.plans.length; index += 1) {
        const clientPlan = {
          planId: '',
          priceId: '',
          typeSignature: typePerson === '1' ? '' : 3,
          customPrice: '',
          numberUser: '',
          price: 0,
        }
        this.dataRegister.plans.push(clientPlan)
      }
    },

    showDetailsPlans(plan) {
      this.planSelectedView = plan
      this.showDetailsPlanModal = true
    },

    handleChangeSelectionPlan(event) {
      if (!event.target.checked) {
        this.dataRegister.plans = this.dataRegister.plans.map((plan) => {
          if (plan.planId === '') {
            return {
              planId: '',
              priceId: '',
              typeSignature: '',
              customPrice: '',
              numberUser: '',
              price: 0,
            }
          }
          return plan
        })
      }

      if (this.dataRegister.client.typePerson === '2') {
        this.calculatePrice()
      }
    },

    calculatePrice() {
      const { typePerson } = this.dataRegister.client

      if (typePerson === '1') {
        this.dataRegister.plans = this.dataRegister.plans.map((plan) => {
          if (
            plan.planId !== '' &&
            plan.priceId !== '' &&
            plan.typeSignature !== ''
          ) {
            if (plan.priceId === '0') {
              const planSelected = this.plans.find(
                (listPlan) => listPlan.id === plan.planId,
              )

              const price =
                plan.typeSignature === '1'
                  ? planSelected.valueMonthlyPaymentPerUser * plan.numberUser
                  : planSelected.valueAnnualPaymentPerUser * plan.numberUser

              return {
                ...plan,
                customPrice: 1,
                numberUser: plan.numberUser,
                price,
              }
            }
            const planPriceSelected = this.plans
              .find((listPlan) => listPlan.id === plan.planId)
              .prices.find((listPrice) => listPrice.id === plan.priceId)

            const price =
              plan.typeSignature === '1'
                ? planPriceSelected.monthlyPrice
                : planPriceSelected.annualPrice

            return { ...plan, customPrice: '', numberUser: '', price }
          }
          return plan
        })
      } else if (typePerson === '2') {
        this.dataRegister.plans = this.dataRegister.plans.map((plan) => {
          if (plan.planId !== '') {
            const planSelected = this.plans.find(
              (listPlan) => listPlan.id === plan.planId,
            )

            const price = planSelected.valueSinglePayment

            return { ...plan, price }
          }
          return plan
        })
      }
    },

    async createRegister() {
      if (!this.v$.$invalid && this.validatePlansSelected()) {
        this.handleDataRegister()

        this.disableButton = true
        try {
          const response = await this.$store.dispatch(
            'createRegister',
            this.dataRegister,
          )
          this.disableButton = false

          if (response && response.message) {
            this.$root.$refs.notification.success(response.message)
            this.$router.push(PATHS.AUTH)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    validatePlansSelected() {
      const plansSelected = this.dataRegister.plans.filter(
        (plan) => plan.planId !== '',
      )

      if (plansSelected.length === 0) {
        this.$root.$refs.notification.warning(
          'Você deve selecionar pelo menos um plano.',
        )
        return false
      }

      if (this.dataRegister.client.typePerson === '1') {
        let planOk = true

        plansSelected.forEach((plan) => {
          if (plan.priceId === '' || plan.typeSignature === '') {
            planOk = false
          }
          if (
            plan.priceId === '0' &&
            (plan.numberUser === '' || plan.numberUser <= 0)
          ) {
            planOk = false
          }
        })

        if (!planOk) {
          this.$root.$refs.notification.warning(
            'Por favor, selecione o "Número de Usuários" e o "Tipo de Assinatura" nos planos selecionados.',
          )
          return false
        }
      }

      return true
    },

    handleDataRegister() {
      if (this.dataRegister.client.typePerson === '2') {
        this.dataRegister.user = {
          name: this.dataRegister.client.socialName,
          chapa: '',
          email: this.dataRegister.client.email,
          phone: this.dataRegister.client.phone,
        }
      }
    },
  },

  validations() {
    return {
      dataRegister: {
        client: {
          cnpjcpf: {
            required,
            minLength: minLength(14),
            maxLength: maxLength(18),
          },
          socialName: {
            required,
          },
          fantasyName: {
            required: requiredIf(() => {
              if (this.dataRegister.client.typePerson === '1') {
                return true
              }
              return false
            }),
          },
          address: {
            required,
          },
          number: {
            required,
          },
          district: {
            required,
          },
          city: {
            required,
          },
          stage: {
            required,
          },
          phone: {
            required,
            minLength: minLength(14),
            maxLength: maxLength(15),
          },
          email: {
            required,
            email,
          },
          acceptedTerm: {
            required,
          },
        },
        user: {
          name: {
            required: requiredIf(() => {
              if (this.dataRegister.client.typePerson === '1') {
                return true
              }
              return false
            }),
            minLength: minLength(8),
          },
          email: {
            required: requiredIf(() => {
              if (this.dataRegister.client.typePerson === '1') {
                return true
              }
              return false
            }),
            email,
          },
          phone: {
            minLength: minLength(14),
            maxLength: maxLength(15),
          },
        },
      },
    }
  },

  mounted() {
    this.dataRegister.client.typePerson = '1'
  },
}
</script>
